import React from 'react';
import { Outlet } from 'react-router-dom';
import { TopBar } from './TopBar';

export const Layout: React.FC = () => {
  return (
    <div className="h-full">
      <TopBar />
      <main className="pt-16 h-full">
        <Outlet />
      </main>
    </div>
  );
};
